<span [style.color]="color" [style.background]="lightenColor(color)" class="badge-pill">{{text | titlecase }}</span>